import React from 'react';

function ArrowSquareDown(props) {
  return (
    <svg height={24} width={24} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2 19.75C2 20.9926 3.00736 22 4.25 22H19.75C20.9926 22 22 20.9926 22 19.75V4.25C22 3.00736 20.9926 2 19.75 2H4.25C3.00736 2 2 3.00736 2 4.25L2 19.75ZM7.56716 12.0579C7.8114 11.814 8.20713 11.8143 8.45104 12.0585L11.3806 14.9922V7.60945C11.3806 7.26427 11.6604 6.98445 12.0056 6.98445C12.3508 6.98445 12.6306 7.26427 12.6306 7.60945V14.9887L15.5604 12.0583C15.8044 11.8142 16.2001 11.8141 16.4443 12.0582C16.6884 12.3022 16.6884 12.698 16.4443 12.9421L12.6221 16.7651C12.2802 17.1071 11.7258 17.1069 11.3842 16.7648L7.56654 12.9418C7.32263 12.6976 7.32291 12.3018 7.56716 12.0579Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default ArrowSquareDown;
